import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { ShieldCheck } from "lucide-react";

export default function ChefRondes() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/rondes"
      eyebrow="Sécurité · Rondes"
      title="Registre des rondes"
      sub="Suivez les rondes de vos agents : sites, points contrôlés, anomalies."
      testidPrefix="ronde"
      defaultRow={() => ({ site: "", agent: "", debut: new Date().toISOString().slice(0, 16), fin: "", points_controles: [], anomalies: "", notes: "" })}
      columns={[
        { key: "site", label: "Site" },
        { key: "agent", label: "Agent", width: "180px" },
        { key: "debut", label: "Début", width: "180px", render: (v) => v ? new Date(v).toLocaleString("fr-FR") : "—" },
        { key: "fin", label: "Fin", width: "180px", render: (v) => v ? new Date(v).toLocaleString("fr-FR") : <span className="text-[#FFD700] font-bold">En cours</span> },
        { key: "anomalies", label: "Anomalies", render: (v) => v ? <span className="text-[#E60000]">{v}</span> : "—" },
      ]}
      fields={[
        { key: "site", label: "Site / Lieu", span: 6, required: true },
        { key: "agent", label: "Agent en charge", span: 6, required: true },
        { key: "debut", label: "Début (date & heure)", type: "datetime-local", span: 6, required: true },
        { key: "fin", label: "Fin (date & heure)", type: "datetime-local", span: 6 },
        { key: "anomalies", label: "Anomalies relevées", type: "textarea", span: 12 },
        { key: "notes", label: "Notes additionnelles", type: "textarea", span: 12 },
      ]}
      emptyIcon={ShieldCheck}
      emptyText="Aucune ronde enregistrée. Cliquez sur Ajouter."
    />
  );
}
